// extracted by mini-css-extract-plugin
module.exports = {"fullName":"user_fullName__2pLsu","userName":"user_userName__1l9RM","title":"user_title__8F5aR","overwrite":"user_overwrite__h1jCd","teamName":"user_teamName__12O9c"};